import React, { useEffect, useState } from "react";
import "./VariantSelectionPopup.css";

const VariantSelectionPopup = ({
    open,
    onClose,
    product,
    onSubmit,
    mode,
    onPreOrderSubmit,
}) => {
    const [selected, setSelected] = useState([]);
    const [weight, setWeight] = useState(""); // pre-order weight

    const variants = product?.product_variant || product?.product_variants || [];
    const hasCartItem = variants.some((v) => v.cart_id);

    useEffect(() => {
        if (variants.length > 0) {
            const preSelected = variants
                .filter((v) => v.cart_id)
                .map((v) => v.product_variant_id);
            setSelected(preSelected);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product]);

    if (!open || !product) return null;

    const isPreOrder = mode === "preorder";

    const categoryName = product?.product_category_name?.toLowerCase();
    const isRing = categoryName === "ring";
    const isBangle = categoryName === "bangle";
    const hasSize = isRing || isBangle;
    const sizeLabel = isRing ? "Ring Size" : "Bangle Size";

    const toggleVariant = (id) =>
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
        );

    const selectedQty = variants
        .filter((v) => selected.includes(v.product_variant_id))
        .reduce((sum, v) => sum + Number(v.product_packaging_quantity || 0), 0);

    const totalAvailableQty = variants.reduce(
        (sum, v) => sum + Number(v.product_packaging_quantity || 0),
        0,
    );
    const minQty = Math.min(
        Number(product?.min_quantity || 0),
        totalAvailableQty,
    );
    const isBelowMinQty = selectedQty < minQty;

    const handleSubmit = () => {
        if (isPreOrder) {
            onPreOrderSubmit({
                product_id: product.product_id,
                pre_order_weight: Number(weight),
            });
        } else {
            onSubmit(selected);
        }
    };

    return (
        <div className="variant-popup-overlay">
            <div className="variant-popup">
                <span className="close-btn-variant-popup" onClick={onClose}>
                    ✕
                </span>

                <div className="header-variant-popup">
                    <p className="p-1">{isPreOrder ? "Pre-Order Request" : "Variants"}</p>

                    {!isPreOrder && (
                        <p className="p-1">Min Order Qty : {product?.min_quantity}</p>
                    )}
                </div>

                {isPreOrder ? (
                    <>
                        <p>Enter Required Weight (gm)</p>
                        <input
                            type="number"
                            className="weight-input"
                            placeholder="e.g. 2.5"
                            min={0}
                            step="0.1"
                            value={weight}
                            onChange={(e) => setWeight(e.target.value)}
                        />
                    </>
                ) : (
                    <>
                        <div
                            className={`table-header-variant-popup ${hasSize ? "has-size" : ""}`}
                        >
                            <span></span>
                            <span>Gross Wt</span>
                            <span>Net Wt</span>
                            <span>Qty</span>
                            <span>Stone Rate</span>
                            {hasSize && <span>{sizeLabel}</span>}
                        </div>

                        {variants.map((v) => (
                            <div
                                key={v.product_variant_id}
                                className={`variant-row ${selected.includes(v.product_variant_id) ? "selected" : ""
                                    } ${hasSize ? "has-size" : ""}`}
                                onClick={() => toggleVariant(v.product_variant_id)}
                            >
                                <input
                                    type="checkbox"
                                    checked={selected.includes(v.product_variant_id)}
                                    readOnly
                                />
                                <span>{v.product_gross_weight} gm</span>
                                <span>{v.product_net_weight} gm</span>
                                <span>{v.product_packaging_quantity} Pcs</span>
                                <span>{v.product_stone_rate ?? "-"}</span>
                                {/* if bangles use a different field, change it here */}
                                {hasSize && <span>{v.product_ring_size || "-"}</span>}
                            </div>
                        ))}
                    </>
                )}

                {!isPreOrder && selected.length > 0 && isBelowMinQty && (
                    <p className="min-qty-warning">
                        Select at least {minQty} Pcs (selected: {selectedQty})
                    </p>
                )}
                <button
                    className="add-btn-variant-popup"
                    disabled={isPreOrder ? !weight : selected.length === 0 || isBelowMinQty}
                    onClick={handleSubmit}
                >
                    {isPreOrder
                        ? "Submit Pre-Order"
                        : hasCartItem
                            ? "Update Cart"
                            : "Add to Cart"}
                </button>
            </div>
        </div>
    );
};

export default VariantSelectionPopup;